<template>
  <div class="up-text-book">

    <HeadBtn @addBtn='addBtn' @resetBtn="resetBtn" :searchForm='searchForm' @searchFormData='searchFormData'
      :selectDict='selectDict' />

    <AddETextBook @addSuccess='addSuccess' :rowData.sync='rowData' :type='type'
      :centerDialogVisible.sync='centerDialogVisible' :form='form' :selectDict='selectDict' />

    <Table :tableData='tableData' :isBooks='true' @handleDelete='handleDelete' />

  </div>
</template>

<script>
import HeadBtn from "@/views/profile/components/mine/myUpload/common/HeadBtn";
import AddETextBook from "@/views/profile/components/mine/myUpload/eTextbook/components/AddETextBook";
import Table from "@/views/profile/components/mine/myUpload/common/Table";

import {
  getDictBatch,
  getPageTextbook,
  delTextbook,
  IdGetResource
} from "@/network/resourceRequest/api";

import utils from "@/util/index";

export default {
  name: "UpTextbook",
  components: { HeadBtn, AddETextBook, Table },
  props: {
    //当前页面--------------------------------------------
    currentPage: {},
    //总页码--------------------------------------------
    pageTotal: {}
  },

  data() {
    return {
      tableData: [],
      //筛选条件--------------------------------------------
      fd: {
        pageNum: 1,
        pageSize: 8
      },

      //文件信息--------------------------------------------
      form: {
        name: "", //教材名称
        course: "", //科目
        phase: "", //学段
        grade: "", //年级
        volume: "", //册别
        edition: "", //出版社
        label: "", //教材性质
        toll: "", //是否收费
        openState: 1, //公开状态
        fileId: "", //文件id凭证
        fileIdList: [], //文件id列表
        coverId: "", //封面id凭证
        id: 0, //资源id
        label: "" //标签属性
      },

      //添加还是修改--------------------------------------------
      type: "",
      //编辑的数据--------------------------------------------
      rowData: "",

      //筛选字典--------------------------------------------
      selectDict: [],

      //显示添加或编辑--------------------------------------------
      centerDialogVisible: false,

      //搜索条件--------------------------------------------
      searchForm: {}
    };
  },

  created() {
    //初始化数据--------------------------------------------
    this._initData();
    this._getTableData();
  },

  watch: {
    currentPage(newPage) {
      this.$set(this.fd, "pageNum", newPage);
      this._getTableData();
    }
  },

  methods: {
    _initData() {
      //类型:course学科,phase学段,grade年级,volume册别,edition教材版本,textbook_label教材性质,qtype题型,rtype同步资源类型,ftype文件格式类型,ptype卷库类型
      let data = {
        types: "course,phase,grade,volume,edition,textbook_label"
      };

      getDictBatch(data).then(res => {
        if (res.data.success) {
          this.selectDict = res.data.data;
        }
      });
    },

    //添加按钮
    addBtn() {
      this.type = "add";
      this.centerDialogVisible = true;
    },

    //取消收藏 (1编辑  2删除)
    handleDelete(scope, type) {
      if (type == 1) {
        IdGetResource("textbook", scope.row.id).then(res => {
          this.rowData = res.data.data;
          this.type = "set";
          this.form.id = res.data.data.id;
          for (const key in this.form) {
            if (this.form.hasOwnProperty(key)) {
              this.$set(
                this.form,
                key,
                res.data.data.hasOwnProperty(key) ? res.data.data[key] : ""
              );
            }
          }
          this.centerDialogVisible = true;
        });
      }

      //删除
      if (type == 2) {
        delTextbook(scope.row.id).then(res => {
          if (res.data.success) {
            utils.tips("success", res.data.code);
            //更新
            this._getTableData();
          } else {
            console.log("CoTextbook", res.data.code);
          }
        });
      }
    },

    //查询按钮返回的数据
    searchFormData(searchFormData) {
      this.fd = {
        pageNum: 1,
        pageSize: 8
      };

      for (const key in searchFormData) {
        if (
          searchFormData.hasOwnProperty(key) &&
          searchFormData[key] &&
          searchFormData[key] != "全部"
        ) {
          this.fd[key] = searchFormData[key];
        }
      }
      this._getTableData();
    },

    //添加成功更新表格
    addSuccess() {
      this.$emit("update:currentPage", 1);
      this._getTableData();
    },

    //重置表格数据
    resetBtn() {
      this.searchForm = {};
      this.fd = {
        pageNum: 1,
        pageSize: 8
      };
      this.$emit("update:currentPage", 1);
      this._getTableData();
    },

    //获取表格数据--------------------------------------------
    _getTableData() {
      getPageTextbook(this.fd).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list;
          this.$emit("update:pageTotal", res.data.data.total);
        } else {
          console.log("CoTextbook", res.data.code);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>